/**
 * Chat copy + helpers for capturing KiTa / Hort attendance weekdays.
 */

import {
  formatKitaWeekdaysLabel,
  KITA_WEEKDAY_OPTIONS,
} from "./kitaRelevance";
import { isKitaChild, normalizeChildren, withWeekdaysOnChild } from "./familyChildren";

export { KITA_WEEKDAY_OPTIONS };

export const KITA_DAYS_FLOW_TEXT = {
  ask: "An welchen Tagen ist euer Kind in der KiTa? Tippe die Tage an.",
  needOne: "Wähle mindestens einen Tag — oder überspringe.",
  saved: (days) => `Merci — KiTa-Tage ${formatKitaWeekdaysLabel(days)}.`,
  skipped: "Alles klar. Du kannst die Tage später im Chat nachtragen.",
};

/**
 * Apply kita_weekdays to one child, or to all KiTa children when childId is omitted.
 * @param {unknown} children
 * @param {number[]} kitaWeekdays
 * @param {string|null} [childId]
 */
export function withKitaWeekdaysOnChildren(children, kitaWeekdays, childId = null) {
  const list = normalizeChildren(children);
  if (childId) return withWeekdaysOnChild(list, childId, "kita", kitaWeekdays);
  const kitaKids = list.filter((c) => isKitaChild(c));
  const targets = kitaKids.length > 0 ? kitaKids : list;
  if (targets.length === 0) {
    return withWeekdaysOnChild([{ birth_ym: null }], null, "kita", kitaWeekdays);
  }
  let next = list.length > 0 ? list : targets;
  for (const child of targets) {
    next = withWeekdaysOnChild(next, child.id, "kita", kitaWeekdays);
  }
  return next;
}
